function getFocusableElements(container){return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))}
const trapFocusHandlers={}
function removeTrapFocus(elementToFocus=null){document.removeEventListener("focusin",trapFocusHandlers.focusin)
document.removeEventListener("focusout",trapFocusHandlers.focusout)
document.removeEventListener("keydown",trapFocusHandlers.keydown)
if(elementToFocus)elementToFocus.focus()}
function trapFocus(container,elementToFocus=container){var elements=getFocusableElements(container)
var first=elements[0]
var last=elements[elements.length-1]
removeTrapFocus()
trapFocusHandlers.focusin=(event)=>{if(event.target!==container&&event.target!==last&&event.target!==first)return
document.addEventListener("keydown",trapFocusHandlers.keydown)}
trapFocusHandlers.focusout=function(){document.removeEventListener("keydown",trapFocusHandlers.keydown)}
trapFocusHandlers.keydown=function(event){if(event.code.toUpperCase()!=="TAB")return
if(event.target===last&&!event.shiftKey){event.preventDefault()
first.focus()}
if((event.target===container||event.target===first)&&event.shiftKey){event.preventDefault()
last.focus()}}
document.addEventListener("focusout",trapFocusHandlers.focusout)
document.addEventListener("focusin",trapFocusHandlers.focusin)
elementToFocus.focus()}
function onKeyUpEscape(event){if(event.code.toUpperCase()!=="ESCAPE")return
const openDetailsElement=event.target.closest("details[open]")
if(!openDetailsElement)return
const summaryElement=openDetailsElement.querySelector("summary")
openDetailsElement.removeAttribute("open")
summaryElement.focus()}
class MenuDrawer extends HTMLElement{constructor(){super()
this.mainDetailsToggle=this.querySelector("details")
const summaryElements=this.querySelectorAll("summary")
this.addAccessibilityAttributes(summaryElements)
if(navigator.platform==="iPhone")
document.documentElement.style.setProperty("--viewport-height",`${window.innerHeight}px`)
this.addEventListener("keyup",this.onKeyUp.bind(this))
this.addEventListener("focusout",this.onFocusOut.bind(this))
this.bindEvents()}
bindEvents(){this.querySelectorAll("summary").forEach((summary)=>summary.addEventListener("click",this.onSummaryClick.bind(this)))
this.querySelectorAll("button").forEach((button)=>button.addEventListener("click",this.onCloseButtonClick.bind(this)))}
addAccessibilityAttributes(summaryElements){summaryElements.forEach((element)=>{element.setAttribute("role","button")
element.setAttribute("aria-expanded",!1)
element.setAttribute("aria-controls",element.nextElementSibling.id)})}
onKeyUp(event){if(event.code.toUpperCase()!=="ESCAPE")return
const openDetailsElement=event.target.closest("details[open]")
if(!openDetailsElement)return
openDetailsElement===this.mainDetailsToggle?this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")):this.closeSubmenu(openDetailsElement)}
onSummaryClick(event){const summaryElement=event.currentTarget
const detailsElement=summaryElement.parentNode
const isOpen=detailsElement.hasAttribute("open")
if(detailsElement===this.mainDetailsToggle){if(isOpen)event.preventDefault()
isOpen?this.closeMenuDrawer(summaryElement):this.openMenuDrawer(summaryElement)}else{trapFocus(summaryElement.nextElementSibling,detailsElement.querySelector("button"))
setTimeout(()=>{detailsElement.classList.add("menu-opening")})}}
openMenuDrawer(summaryElement){setTimeout(()=>{this.mainDetailsToggle.classList.add("menu-opening")})
summaryElement.setAttribute("aria-expanded",!0)
trapFocus(this.mainDetailsToggle,summaryElement)
document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)}
closeMenuDrawer(event,elementToFocus=!1){if(event!==undefined){this.mainDetailsToggle.classList.remove("menu-opening")
this.mainDetailsToggle.querySelectorAll("details").forEach((details)=>{details.removeAttribute("open")
details.classList.remove("menu-opening")})
this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded",!1)
document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
removeTrapFocus(elementToFocus)
this.closeAnimation(this.mainDetailsToggle)}}
onFocusOut(event){setTimeout(()=>{if(this.mainDetailsToggle.hasAttribute("open")&&!this.mainDetailsToggle.contains(document.activeElement))
this.closeMenuDrawer()})}
onCloseButtonClick(event){const detailsElement=event.currentTarget.closest("details")
this.closeSubmenu(detailsElement)}
closeSubmenu(detailsElement){detailsElement.classList.remove("menu-opening")
removeTrapFocus()
this.closeAnimation(detailsElement)}
closeAnimation(detailsElement){let animationStart
const handleAnimation=(time)=>{if(animationStart===undefined){animationStart=time}
const elapsedTime=time-animationStart
if(elapsedTime<400){window.requestAnimationFrame(handleAnimation)}else{detailsElement.removeAttribute("open")
if(detailsElement.closest("details[open]")){trapFocus(detailsElement.closest("details[open]"),detailsElement.querySelector("summary"))}}}
window.requestAnimationFrame(handleAnimation)}}
customElements.define("menu-drawer",MenuDrawer)
function debounce(fn,wait){let t
return(...args)=>{clearTimeout(t)
t=setTimeout(()=>fn.apply(this,args),wait)}}
const serializeForm=(form)=>{const obj={}
const formData=new FormData(form)
for(const key of formData.keys()){obj[key]=formData.get(key)}
return JSON.stringify(obj)}
class FacetFiltersForm extends HTMLElement{constructor(){super()
this.onActiveFilterClick=this.onActiveFilterClick.bind(this)
this.debouncedOnSubmit=debounce((event)=>{this.onSubmitHandler(event)},500)
this.querySelector("form").addEventListener("input",this.debouncedOnSubmit.bind(this))
const facetWrapper=this.querySelector("#FacetsWrapperDesktop")
if(facetWrapper)facetWrapper.addEventListener("keyup",onKeyUpEscape)}
static setListeners(){const onHistoryChange=(event)=>{const searchParams=event.state?event.state.searchParams:FacetFiltersForm.searchParamsInitial
if(searchParams===FacetFiltersForm.searchParamsPrev)return
FacetFiltersForm.renderPage(searchParams,null,!1)}
window.addEventListener("popstate",onHistoryChange)}
static toggleActiveFacets(disable=!0){document.querySelectorAll(".js-facet-remove").forEach((element)=>{element.classList.toggle("disabled",disable)})}
static renderPage(searchParams,event,updateURLHash=!0){FacetFiltersForm.searchParamsPrev=searchParams
const sections=FacetFiltersForm.getSections()
const countContainer=document.getElementById("ProductCount")
const countContainerDesktop=document.getElementById("ProductCountDesktop")
document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading")
if(countContainer){countContainer.classList.add("loading")}
if(countContainerDesktop){countContainerDesktop.classList.add("loading")}
sections.forEach((section)=>{debugger
const url=`${window.location.pathname}?section_id=${section.section}&${searchParams}`
const filterDataUrl=(element)=>element.url===url
FacetFiltersForm.filterData.some(filterDataUrl)?FacetFiltersForm.renderSectionFromCache(filterDataUrl,event):FacetFiltersForm.renderSectionFromFetch(url,event)})
if(updateURLHash)FacetFiltersForm.updateURLHash(searchParams)}
static renderSectionFromFetch(url,event){fetch(url).then((response)=>response.text()).then((responseText)=>{const html=responseText
FacetFiltersForm.filterData=[...FacetFiltersForm.filterData,{html,url}]
FacetFiltersForm.renderFilters(html,event)
FacetFiltersForm.renderProductGridContainer(html)
FacetFiltersForm.renderProductCount(html)})}
static renderSectionFromCache(filterDataUrl,event){const html=FacetFiltersForm.filterData.find(filterDataUrl).html
FacetFiltersForm.renderFilters(html,event)
FacetFiltersForm.renderProductGridContainer(html)
FacetFiltersForm.renderProductCount(html)}
static renderProductGridContainer(html){document.getElementById("ProductGridContainer").innerHTML=new DOMParser().parseFromString(html,"text/html").getElementById("ProductGridContainer").innerHTML}
static renderProductCount(html){const count=new DOMParser().parseFromString(html,"text/html").getElementById("ProductCount").innerHTML
const container=document.getElementById("ProductCount")
const containerDesktop=document.getElementById("ProductCountDesktop")
container.innerHTML=count
container.classList.remove("loading")
if(containerDesktop){containerDesktop.innerHTML=count
containerDesktop.classList.remove("loading")}}
static renderFilters(html,event){const parsedHTML=new DOMParser().parseFromString(html,"text/html")
const facetDetailsElements=parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter")
const matchesIndex=(element)=>{const jsFilter=event?event.target.closest(".js-filter"):undefined
return jsFilter?element.dataset.index===jsFilter.dataset.index:!1}
const facetsToRender=Array.from(facetDetailsElements).filter((element)=>!matchesIndex(element))
const countsToRender=Array.from(facetDetailsElements).find(matchesIndex)
facetsToRender.forEach((element)=>{document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML=element.innerHTML})
FacetFiltersForm.renderActiveFacets(parsedHTML)
FacetFiltersForm.renderAdditionalElements(parsedHTML)
if(countsToRender)FacetFiltersForm.renderCounts(countsToRender,event.target.closest(".js-filter"))}
static renderActiveFacets(html){const activeFacetElementSelectors=[".active-facets-mobile",".active-facets-desktop"]
activeFacetElementSelectors.forEach((selector)=>{const activeFacetsElement=html.querySelector(selector)
if(!activeFacetsElement)return
document.querySelector(selector).innerHTML=activeFacetsElement.innerHTML})
FacetFiltersForm.toggleActiveFacets(!1)}
static renderAdditionalElements(html){const mobileElementSelectors=[".mobile-facets__open",".mobile-facets__count",".sorting"]
mobileElementSelectors.forEach((selector)=>{if(!html.querySelector(selector))return
document.querySelector(selector).innerHTML=html.querySelector(selector).innerHTML})
document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()}
static renderCounts(source,target){const targetElement=target.querySelector(".facets__selected")
const sourceElement=source.querySelector(".facets__selected")
if(sourceElement&&targetElement){target.querySelector(".facets__selected").outerHTML=source.querySelector(".facets__selected").outerHTML}}
static updateURLHash(searchParams){history.pushState({searchParams},"",`${window.location.pathname}${searchParams && "?".concat(searchParams)}`)}
static getSections(){return[{section:document.getElementById("product-grid").dataset.id,},]}
onSubmitHandler(event){event.preventDefault()
const formData=new FormData(event.target.closest("form"))
const searchParams=new URLSearchParams(formData).toString()
FacetFiltersForm.renderPage(searchParams,event)}
onActiveFilterClick(event){event.preventDefault()
FacetFiltersForm.toggleActiveFacets()
const url=event.currentTarget.href.indexOf("?")==-1?"":event.currentTarget.href.slice(event.currentTarget.href.indexOf("?")+1)
FacetFiltersForm.renderPage(url)}}
FacetFiltersForm.filterData=[]
FacetFiltersForm.searchParamsInitial=window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev=window.location.search.slice(1)
customElements.define("facet-filters-form",FacetFiltersForm)
FacetFiltersForm.setListeners()
class PriceRange extends HTMLElement{constructor(){super()
this.querySelectorAll("input").forEach((element)=>element.addEventListener("change",this.onRangeChange.bind(this)))
this.setMinAndMaxValues()}
onRangeChange(event){this.adjustToValidValues(event.currentTarget)
this.setMinAndMaxValues()}
setMinAndMaxValues(){const inputs=this.querySelectorAll("input")
const minInput=inputs[0]
const maxInput=inputs[1]
if(maxInput.value)minInput.setAttribute("max",maxInput.value)
if(minInput.value)maxInput.setAttribute("min",minInput.value)
if(minInput.value==="")maxInput.setAttribute("min",0)
if(maxInput.value==="")minInput.setAttribute("max",maxInput.getAttribute("max"))}
adjustToValidValues(input){const value=Number(input.value)
const min=Number(input.getAttribute("min"))
const max=Number(input.getAttribute("max"))
if(value<min)input.value=min
if(value>max)input.value=max}}
customElements.define("price-range",PriceRange)
class FacetRemove extends HTMLElement{constructor(){super()
this.querySelector("a").addEventListener("click",(event)=>{event.preventDefault()
const form=this.closest("facet-filters-form")||document.querySelector("facet-filters-form")
form.onActiveFilterClick(event)})}}
customElements.define("facet-remove",FacetRemove)